module.exports = __webpack_public_path__ + "static/img/海报设计-平面合成海报.43c3a1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10001/海报设计-平面合成海报.png
// module id = 1APZ
// module chunks = 1